import { Card, Button, Avatar, Space } from 'antd';
import { ShopOutlined, UserOutlined } from '@ant-design/icons';
import type { TenantOrder } from '@/mocks/orders';
import type { TenantStaff } from '@/mocks/staffs';
import { formatAmisEmployee } from '@/utils/amisEmployee';

interface BranchCardProps {
  order: TenantOrder;
  onEdit?: () => void;
  /** Bỏ ảnh đại diện cho gọn — pop-up xem nhanh dùng (TCR-1095). */
  hideAvatar?: boolean;
}

export function BranchCard({ order, onEdit, hideAvatar }: BranchCardProps) {
  const { store } = order;

  return (
    <Card
      title="Chi nhánh"
      size="small"
      extra={
        onEdit && <Button size="small" onClick={onEdit}>
          Đổi chi nhánh
        </Button>
      }
    >
      <Space align="start" size="middle" style={{ width: '100%' }}>
        {!hideAvatar && <Avatar size={36} icon={<ShopOutlined />} style={{ backgroundColor: '#237804' }} />}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 14 }}>
            {store?.name || 'Chưa có'}
          </div>
          <div style={{ color: '#666', fontSize: 13, marginTop: 2 }}>
            {store?.address || 'Chưa có'}
          </div>
        </div>
      </Space>
    </Card>
  );
}

interface StaffCardProps {
  order: TenantOrder;
  staffs?: Array<Pick<TenantStaff, 'staff_id' | 'name' | 'amisEmployee'>>;
  onEdit?: () => void;
  /** Bỏ ảnh đại diện cho gọn — pop-up xem nhanh dùng (TCR-1095). */
  hideAvatar?: boolean;
}

export function StaffCard({ order, staffs, onEdit, hideAvatar }: StaffCardProps) {
  const { cashier } = order;
  const cashierName = cashier?.name || staffs?.find(s => s.staff_id === cashier?.staff_id)?.name;
  const staffName = cashierName || 'Chưa có';
  // TCR-2492 — mã + tên nhân viên AMIS của người bán (chỉ các mapping đã map).
  const amisEntries = (staffs?.find((s) => s.staff_id === cashier?.staff_id)?.amisEmployee ?? []).filter(
    (e) => e.amis_refid !== null,
  );

  return (
    <Card
      title="Nhân viên phụ trách"
      size="small"
      extra={
        onEdit && <Button size="small" onClick={onEdit}>
          Đổi nhân viên
        </Button>
      }
    >
      <Space align="start" size="middle" style={{ width: '100%' }}>
        {!hideAvatar && <Avatar size={36} icon={<UserOutlined />} style={{ backgroundColor: '#722ed1' }} />}
        <div style={{ flex: 1, minWidth: 0 }}>
          <div style={{ fontWeight: 600, fontSize: 14 }}>
            {staffName}
          </div>
          <div style={{ color: '#666', fontSize: 13, marginTop: 2 }}>
            Nhân viên bán hàng
          </div>
          {amisEntries.map((e) => (
            <div key={e.amis_tenant_id} data-testid="staff-card-amis" style={{ color: '#8c8c8c', fontSize: 12, marginTop: 2 }}>
              AMIS: {formatAmisEmployee(e)}
            </div>
          ))}
        </div>
      </Space>
    </Card>
  );
}
